module.exports = __webpack_public_path__ + "img/bank-hide-mismatch.50c44ff8.svg";